'use strict';

var Backbone = require('backbone');
var Marker = require('../models/marker').default;
var _ = require('underscore');
var MarkerCollection = Backbone.Collection.extend({

  model: Marker,
  comparator: function (a, b) {
    if (a.get('virtual') && !b.get('virtual')) return -1;
    if (b.get('virtual') && !a.get('virtual')) return 1;

    if (!(this.latitude && this.longitude)) {
      if (a.get('sort_order') > b.get('sort_order')) return 1;
      if (a.get('sort_order') < b.get('sort_order')) return -1;
      return 0;
    }

    var distance1 = a.distanceFromPoint(this.latitude, this.longitude),
      distance2 = b.distanceFromPoint(this.latitude, this.longitude);

    if (distance1 > distance2) return 1;
    if (distance1 < distance2) return -1;
    return 0;
  },

  initialize: function (models, options) {
    options = options || {};
    this.latitude = options.latitude || null;
    this.longitude = options.longitude || null;
    this.services = options.services || [];
  },

  setPosition: function (latitude, longitude) {
    this.latitude = latitude;
    this.longitude = longitude;
  },

  searchByPositionAndDistance: function (latitude, longitude, distance) {
    var self = this;
    var models = this.filter(function (marker) {
      return marker.distanceFromPoint(latitude, longitude) < distance;
    });

    var collection = new MarkerCollection(models);
    collection.setPosition(latitude, longitude);
    collection.sort();

    return collection;
  },
  /**
   * Checks the array of markers passed in (already filtered through
   * filterByServiceId) to ensure they offer the same services.
   * @param services
   * @returns bool
   */
  sameServices: function (services) {
    return this.every( function (markers) {
      const markerServices = markers.get('services').map((serviceId) => {
        return parseInt(serviceId);
      });

      return _.difference(services, markerServices).length == 0;
    });
  },
  /**
   * If a service_id has been selected (Services appear before Location),
   * ensure that the markers on the map only show locations offering the
   * selected service.
   *
   * @param service_id
   * @returns Collection collection
   */
  filterByServiceId: function (service_id) {
    var self = this;
    //Filter the list of markers
    var models = this.filter(function (marker) {
      //Grab only markers that offer a service matching our service id
      var dot = service_id.some(function(id) {
        return _.contains(marker.get('services'), id.toString());
      });
      return dot;
    });
    var collection = new MarkerCollection(models);
    return collection;
  },
});

export default MarkerCollection;
